import React from 'react';

import {getMarkdownRenderer, type MarkdownRendererProps} from './markdownRendererRef';

/**
 * Statically importable stand-in for MarkdownRendererV2 in leaves that would otherwise form an
 * import cycle with it (see markdownRendererRef). Resolves the registered renderer at render time,
 * so leaves keep the lazy "only resolve when actually rendered" behavior without each of them
 * calling getMarkdownRenderer() during render (which the React Compiler flags as creating a
 * component during render).
 */
export function NestedMarkdown(props: MarkdownRendererProps) {
  const MarkdownRendererV2 = getMarkdownRenderer();
  // oxlint-disable-next-line react/static-components -- see above
  return <MarkdownRendererV2 {...props} />;
}
